import React, { ReactNode } from 'react';
import cn from 'classnames';

import './button.styl';

interface Props {
    children: ReactNode;
    className?: string;
    active?: boolean;
    disabled?: boolean;
    onClick?: React.MouseEventHandler<HTMLButtonElement> | React.TouchEventHandler<HTMLButtonElement>;
    refer?: React.RefObject<HTMLSpanElement>;
}

export const Button = ({ children, active, onClick, refer, className = '', disabled }: Props) => {
    return (
        <span
            onClick={onClick as React.MouseEventHandler<HTMLSpanElement>}
            ref={refer}
            className={cn('common-button', className, { active, disabled })}
        >
            {children}
        </span>
    );
};
